export const SYMBOL = '&';

export default function func(...params: (string | number)[]) {
    return params.reduce((acc, value) => acc + value.toString(), '');
}

func.SYMBOL = SYMBOL;
